import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";
/** @augments {PureComponent<any, any>} */
class Image extends PureComponent {
    render() {
        return (
            <SvgIcon fill="#e1e1e1" {...this.props}>
                <path d="M17.5,7 C19.4329966,7 21,5.43299662 21,3.5 C21,1.56700338 19.4329966,0 17.5,0 C15.5670034,0 14,1.56700338 14,3.5 C14,5.43299662 15.5670034,7 17.5,7 Z M0.719160171,17.9031107 C0.219160171,17.9031107 -0.0808398293,17.4031107 0.0191601707,17.0031107 L4.81916017,4.50311068 C5.01916017,3.90311068 5.81916017,3.80311068 6.11916017,4.40311068 L10.6191602,13.3031107 C10.8191602,13.6031107 11.1191602,13.8031107 11.5191602,13.6031107 L17.3191602,12.0031107 C17.6191602,11.9031107 17.9191602,12.0031107 18.1191602,12.2031107 L23.9191602,16.7031107 C24.2191602,17.2031107 23.9191602,17.9031107 23.3191602,17.9031107 L0.719160171,17.9031107 Z" />
            </SvgIcon>
        );
    }
}

export default Image;
